import { createFileRoute } from "@tanstack/react-router";
import SchedulesTabPanel from "@/components/dashboard/schedules-tab-panel";

export const Route = createFileRoute("/_app/dashboard/schedules/")({
	component: SchedulesTabPanel,
});
